export const environment = {
  production: true, name: "live", host: "hosting:agrologfarmer",
  app: "Agrolog App", key: "live", 
  build: 'live', api: "https://farmer.agrolog.io",
  ws: "wss://farmer.agrolog.io",
  payment: "https://farmer-payment.agrolog.io",
  url: "https://app.agrolog.io",
  analytics: true
};
